import IntlMessages from "components/Message/IntlMessages";
import groupBy from "lodash/groupBy";

export function containsFCDAccount(accounts) {
  return accounts.some((account) => account.currCd && account.currCd.toUpperCase() !== "THB");
}

export function mapAccountsToSelectOptions(accounts, labelProp = "accountNoDisplay", valueProp = "accountNo") {
  const shouldGroupByGlobalAccount = containsFCDAccount(accounts);
  if (shouldGroupByGlobalAccount) {
    const groupedAccountsByGlobalId = groupBy(accounts, "sfcdAccountId");
    const groupIds = Object.keys(groupedAccountsByGlobalId);
    const multipleGlobalGroups = groupIds.length > 1;
    return groupIds
      .sort((a, b) => (a === "null" || a === "undefined" ? 1 : b === "null" || b === "undefined" ? -1 : a - b))
      .map((globalAccountId) => {
        const isFcdSavingGroup = globalAccountId === "null" || globalAccountId === "undefined";
        const label = isFcdSavingGroup
          ? "FCD Saving"
          : `Global Savings ${multipleGlobalGroups ? globalAccountId : ""}`.trim();
        return {
        label,
        options: groupedAccountsByGlobalId[globalAccountId].map((account) => ({
          label: account[labelProp],
          value: account[valueProp],
        })),
      };
      });
  }

  return accounts.map((account) => ({
    label: account[labelProp],
    value: account[valueProp],
  }));
}

export function getAccountNoDisplayInOptions(accountOptions, value) {
  if (!accountOptions) {
    return null;
  }

  let accountNoLabel = null;
  for (const option of accountOptions) {
    if (option.options) {
      accountNoLabel = getAccountNoDisplayInOptions(option.options, value);
    } else {
      if (option.value === value) {
        accountNoLabel = option.label;
      }
    }
  }

  return accountNoLabel;
}

export function getAccountCcyLabel(ccy) {
  if (!ccy) {
    return null;
  }
  if (ccy.toUpperCase() === "THB") {
    return <IntlMessages id="global.unit.baht" />;
  }
  return ccy.toUpperCase();
}
